import {
  CREATE_DATA_MAP_SUCCESS,
  BEGIN_DATA_MAP_SAVE,
  END_DATA_MAP_SAVE,
  DATA_MAP_SET_INITIAL_STATE,
  CLEAR_DATA_MAP_STATE_TO_INITIAL,
  RESET_DELETED_DATA_MAP_ROWS,
  RESET_NEW_DATA_MAP_ROWS,
  RESET_EDITED_DATA_MAP_ROWS,
  UPDATE_DATA_MAP_META,
  CLOSE_DATA_MAP_KEY_FORM,
  ADD_A_NEW_DATA_MAP_ROW,
  SET_DATA_MAP_SEARCH_TERM,
  DELETE_DATA_MAP_PROP_KEY,
  TOGGLE_DATA_MAP_KEY_FORM,
  UPDATE_DATA_MAP_ROW_BEING_ADDED,
  DELETE_DATA_MAP_ROW_BEING_ADDED,
  UPDATE_DATA_MAP_FIELD,
  SET_DATA_MAP_PROPERTY_KEY,
  SET_DATA_MAP_INSERT_TYPE,
  SET_DATA_MAP_WRITE_MODE,
  EDIT_DATA_MAP_BULK_INSERT_TEXT,
  EDIT_DATA_MAP_SELECTED_FILE,
  SET_DATA_MAP_DEFAULT,
  SET_DATA_MAP_PRIMARY_KEY,
  SET_DYNAMIC_DATA_MAP_ROWS,
  UPDATE_DATA_MAP_ROW_CELL,
  DELETE_DATA_MAP_ROW,
  UNDO_DELETE_DATA_MAP_ROW,
  SET_DATA_MAP_KEY_PAGE_FIRST,
  SET_DATA_MAP_KEY_PAGE_PREV,
  SET_DATA_MAP_KEY_PAGE,
  SET_DATA_MAP_KEY_PAGE_NEXT,
  SET_DATA_MAP_KEY_PAGE_LAST,
  LOGOUT_COMPLETE,
} from '../../constants/actionTypes';
import {
  DATA_MAP_RECORDS_PER_PAGE,
  INSERT_TYPE_TABLE,
  INSERT_TYPE_BULK_INSERT,
  INSERT_TYPE_FILE_UPLOAD,
  WRITE_MODE_APPEND,
  WRITE_MODE_OVERWRITE,
} from '../../constants/dataMapConstants';
import { getPropertiesFromCSV } from '../../lib/DataMapsProcessor';

import has from 'lodash/has';
import keys from 'lodash/keys';
import clone from 'lodash/clone';
import cloneDeep from 'lodash/cloneDeep';
import forEach from 'lodash/forEach';
import filter from 'lodash/filter';
import map from 'lodash/map';
import sortBy from 'lodash/sortBy';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';

let initialState = {
  dataMapEntity: null,
  dataMapObj: {
    name: '',
    description: '',
    data_defaults: { key: '', value: '' },
    data_map: [],
    map_primary_key: 'key',
    properties: ['key', 'value'],
    map_entry_schema: {
      properties: {
        key: { name: 'key', id: '1', type: 'string', is_prime_key: true },
        value: { name: 'value', id: '2', type: 'string', is_prime_key: false },
      },
    },
  },

  // props of DataMapsEditForm's popUpForm
  fields: [
    {
      display_name: 'Name',
      id: 'name',
      name: 'name',
      value: '',
      required: true,
    },
    {
      display_name: 'Default',
      id: 'default',
      name: 'default',
      value: '',
      required: true,
    },
    {
      display_name: 'Make primary key',
      id: 'is_prime_key',
      name: 'is_prime_key',
      value: false,
      required: true,
      inputType: 'checkbox',
      description: 'Make primary key',
    },
  ],

  isKeyFormOpen: false,
  popUpFormTitle: null,
  buttonLabel: null,
  propBeingEdited: null,
  propBeingEditedFormerName: null,
  newPrimeKeyId: null,

  keysSearch: '',
  isTypeStatic: true,
  editedRows: {},
  deletedRows: {},
  newRows: [],
  insertType: INSERT_TYPE_TABLE,
  writeMode: WRITE_MODE_APPEND,
  bulkText: null,
  isFileSelected: false,
  arePropertiesChanged: false,
  keysPage: 1,
  keysTotalPage: 1,
  saveComplete: false,
  saveError: null,
};

export const dataMapEditFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_DATA_MAP_STATE_TO_INITIAL:
      return clearStateToInitial(state, action);

    case CREATE_DATA_MAP_SUCCESS:
      return createDataMapInfoSuccess(state, action);

    case DATA_MAP_SET_INITIAL_STATE:
      let { dataMapObj, isTypeStatic } = action.payload;
      return setInitialState(initialState, dataMapObj, isTypeStatic);

    case RESET_DELETED_DATA_MAP_ROWS:
      return resetDeletedDataMapRows(state, action);

    case RESET_NEW_DATA_MAP_ROWS:
      return resetNewDataMapRows(state, action);

    case RESET_EDITED_DATA_MAP_ROWS:
      return resetEditedDataMapRows(state, action);

    case BEGIN_DATA_MAP_SAVE:
      return beginDataMapSave(state, action);

    case END_DATA_MAP_SAVE:
      return endDataMapSave(state, action);

    case UPDATE_DATA_MAP_META:
      return updateMeta(state, action);

    case CLOSE_DATA_MAP_KEY_FORM:
      return closeKeyForm(state, action);

    case ADD_A_NEW_DATA_MAP_ROW:
      return addAnotherNewRow(state, action);

    case SET_DATA_MAP_SEARCH_TERM:
      return setFilterRowSearchTerm(state, action);

    case DELETE_DATA_MAP_PROP_KEY:
      return deleteKey(state, action);

    case TOGGLE_DATA_MAP_KEY_FORM:
      return toggleKeyForm(state, action);

    case UPDATE_DATA_MAP_ROW_BEING_ADDED:
      return updateRowBeingAdded(state, action);

    case DELETE_DATA_MAP_ROW_BEING_ADDED:
      return deleteNewRow(state, action);

    case UPDATE_DATA_MAP_FIELD:
      return onPropKeyFormFieldUpdated(state, action);

    case SET_DATA_MAP_PROPERTY_KEY:
      return onSubmitPropertyForm(state, action);

    case SET_DATA_MAP_INSERT_TYPE:
      return setInsertType(state, action);

    case SET_DATA_MAP_WRITE_MODE:
      return setWriteMode(state, action);

    case EDIT_DATA_MAP_BULK_INSERT_TEXT:
      return onChangeBulkInsert(state, action);

    case EDIT_DATA_MAP_SELECTED_FILE:
      return onChangeSelectedFile(state, action);

    case SET_DATA_MAP_DEFAULT:
      return setDefaultValue(state, action);

    case SET_DATA_MAP_PRIMARY_KEY:
      return setPrimaryKey(state, action);

    case UPDATE_DATA_MAP_ROW_CELL:
      return changeDataMapCell(state, action);

    case DELETE_DATA_MAP_ROW:
      return deleteRow(state, action);

    case UNDO_DELETE_DATA_MAP_ROW:
      return undoDeleteRow(state, action);

    case SET_DATA_MAP_KEY_PAGE_FIRST:
      return onFirstPage(state, action);

    case SET_DATA_MAP_KEY_PAGE_PREV:
      return onPrevPage(state, action);

    case SET_DATA_MAP_KEY_PAGE:
      return onSetPage(state, action);

    case SET_DATA_MAP_KEY_PAGE_NEXT:
      return onNextPage(state, action);

    case SET_DATA_MAP_KEY_PAGE_LAST:
      return onLastPage(state, action);

    case SET_DYNAMIC_DATA_MAP_ROWS:
      return setDynamicDataMapRows(state, action);

    case LOGOUT_COMPLETE:
      return initialState;

    default:
      return state;
  }
};

function setInitialState(state, dataMapObj, isTypeStatic) {
  let { insertType, dataMapEntity } = state;
  let newState = { ...state };

  if (!dataMapEntity && dataMapObj && dataMapObj.id) {
    newState.dataMapEntity = dataMapObj;
  }

  let newDataMapObj = cloneDeep(
    !isEmpty(dataMapObj)
      ? dataMapObj
      : !isEmpty(newState.dataMapEntity)
        ? newState.dataMapEntity
        : newState.dataMapObj,
  );

  if (newDataMapObj.id) {
    let keysPage = 1;
    let keysTotalPage = 1;

    if (insertType !== INSERT_TYPE_FILE_UPLOAD) {
      keysTotalPage = Math.ceil((newDataMapObj.map_entry_count || 0) / DATA_MAP_RECORDS_PER_PAGE);

      let propertiesObj =
        newDataMapObj.map_entry_schema && newDataMapObj.map_entry_schema.properties;

      if (propertiesObj) {
        let { map_primary_key, data_defaults } = newDataMapObj;
        let index = 0; // combine/add info to each property object

        for (var prop in propertiesObj) {
          propertiesObj[prop] = {
            name: prop,
            type: 'string',
            default: data_defaults[prop],
            id: index,
            is_prime_key: prop === map_primary_key,
          };
          index++;
        }
        newDataMapObj.map_entry_schema.properties = propertiesObj;

        let propertiesArray = []; // add a "properties" array prop onto dataMapObject
        forEach(propertiesObj, (item, key) => {
          propertiesArray.push(item.name);
        });
        newDataMapObj.properties = propertiesArray;
      }
    }

    newDataMapObj.name = newDataMapObj.name ? newDataMapObj.name : '';
    newDataMapObj.description = newDataMapObj.description ? newDataMapObj.description : '';

    newState.keysPage = keysPage;
    newState.keysTotalPage = keysTotalPage;
    newState.isTypeStatic = isTypeStatic;
  }

  if (insertType === INSERT_TYPE_FILE_UPLOAD) {
    newDataMapObj.data_defaults = {};
    newDataMapObj.data_map = [];
    newDataMapObj.map_primary_key = '';
    newDataMapObj.properties = [];
    newDataMapObj.map_entry_schema = {
      properties: {},
    };
  }

  newState.dataMapObj = newDataMapObj;

  return newState;
}

function clearStateToInitial(state, action) {
  return { ...initialState };
}

function createDataMapInfoSuccess(state, action) {
  let { dataMapObj } = state;

  return {
    ...state,
    dataMapObj: {
      ...dataMapObj,
      id: action.result,
    },
  };
}

function resetDeletedDataMapRows(state, action) {
  return {
    ...state,
    deletedRows: initialState.deletedRows,
  };
}

function resetNewDataMapRows(state, action) {
  return {
    ...state,
    newRows: initialState.newRows,
  };
}

function resetEditedDataMapRows(state, action) {
  return {
    ...state,
    editedRows: initialState.editedRows,
  };
}

function beginDataMapSave(state, action) {
  return {
    ...state,
    saveComplete: false,
    saveError: null,
  };
}

function endDataMapSave(state, action) {
  const { error } = action.payload;

  return {
    ...state,
    saveComplete: true,
    saveError: error,
  };
}

function setDynamicDataMapRows(state, action) {
  let { dataMapObj } = state;
  // filter out null rows
  let dataMap = filter(action.payload.dynamicDataMapRows);

  return {
    ...state,
    dataMapObj: {
      ...dataMapObj,
      data_map: dataMap,
    },
  };
}

function deleteRow(state, action) {
  let { rowKey } = action.payload;
  let { deletedRows } = state;

  return {
    ...state,
    deletedRows: {
      ...deletedRows,
      [rowKey]: true,
    },
  };
}

function undoDeleteRow(state, action) {
  let { rowKey } = action.payload;
  let { deletedRows } = state;
  let newDeletedRows = { ...deletedRows };
  delete newDeletedRows[rowKey];

  return {
    ...state,
    deletedRows: newDeletedRows,
  };
}

function changeDataMapCell(state, action) {
  let { columnPropertyName, value, rowKey, rowData } = action.payload;
  let { editedRows } = state;
  let newRowData = { ...rowData, [columnPropertyName]: value };

  return {
    ...state,
    editedRows: {
      ...editedRows,
      [rowKey]: newRowData,
    },
  };
}

function onChangeBulkInsert(state, action) {
  let { dataMapEntity, dataMapObj, writeMode } = state;
  let { dataText } = action.payload;
  let { properties, propertiesObj, primaryKey } = getPropertiesFromCSV(
    dataText,
    ',',
    dataMapObj.map_primary_key || (dataMapEntity && dataMapEntity.map_primary_key),
  );
  let arePropertiesEqual = isEqual(properties, dataMapObj.properties);
  let newPropertiesObj;

  if (arePropertiesEqual) {
    newPropertiesObj =
      (dataMapObj.map_entry_schema && dataMapObj.map_entry_schema.properties) || {};
  } else {
    newPropertiesObj = propertiesObj;
  }

  let arePropertiesChanged = !!(
    dataMapEntity &&
    dataMapEntity.map_entry_schema &&
    dataMapEntity.map_entry_schema.properties &&
    !isEqual(sortBy(properties), sortBy(keys(dataMapEntity.map_entry_schema.properties)))
  );
  let newWriteMode = arePropertiesChanged ? WRITE_MODE_OVERWRITE : writeMode;

  return {
    ...state,
    bulkText: dataText,
    dataMapObj: {
      ...dataMapObj,
      map_primary_key: primaryKey,
      properties,
      map_entry_schema: {
        ...dataMapObj.map_entry_schema,
        properties: newPropertiesObj,
      },
    },
    arePropertiesChanged,
    writeMode: newWriteMode,
  };
}

function onChangeSelectedFile(state, action) {
  let { dataMapEntity, dataMapObj, writeMode } = state;
  let { fileContent, dataMapRows } = action.payload;

  if (!fileContent) {
    return {
      ...state,
      dataMapObj: {
        ...dataMapObj,
        id: dataMapObj.id,
        name: dataMapObj.name,
        description: dataMapObj.description,
      },
      isFileSelected: false,
    };
  }

  let { properties, propertiesObj, primaryKey } = getPropertiesFromCSV(
    fileContent,
    ',',
    dataMapObj.map_primary_key || (dataMapEntity && dataMapEntity.map_primary_key),
  );
  let arePropertiesEqual = isEqual(properties, dataMapObj.properties);
  let newPropertiesObj;

  if (arePropertiesEqual) {
    newPropertiesObj =
      (dataMapObj.map_entry_schema && dataMapObj.map_entry_schema.properties) || {};
  } else {
    newPropertiesObj = propertiesObj;
  }

  let arePropertiesChanged = !!(
    dataMapEntity &&
    dataMapEntity.map_entry_schema &&
    dataMapEntity.map_entry_schema.properties &&
    !isEqual(sortBy(properties), sortBy(keys(dataMapEntity.map_entry_schema.properties)))
  );
  let newWriteMode = arePropertiesChanged ? WRITE_MODE_OVERWRITE : writeMode;

  return {
    ...state,
    dataMapObj: {
      ...dataMapObj,
      data_map: dataMapRows,
      map_primary_key: primaryKey,
      properties,
      map_entry_schema: {
        ...dataMapObj.map_entry_schema,
        properties: newPropertiesObj,
      },
    },
    isFileSelected: true,
    arePropertiesChanged,
    writeMode: newWriteMode,
  };
}

function setInsertType(state, action) {
  let { insertType } = action.payload;
  let { dataMapEntity, dataMapObj } = state;
  // only show property name field in table mode
  let fields = [...state.fields];
  fields[0] = {
    ...fields[0],
    isHiddenField: insertType !== INSERT_TYPE_TABLE,
  };

  let newState = {
    ...initialState,
    dataMapObj,
    dataMapEntity,
    insertType,
    fields,
  };

  if (insertType === INSERT_TYPE_BULK_INSERT) {
    newState.bulkText = (
      dataMapEntity
        ? keys(dataMapEntity.map_entry_schema && dataMapEntity.map_entry_schema.properties)
        : newState.dataMapObj.properties
    ).join(',');
  }

  return setInitialState(newState, null, true);
}

function setWriteMode(state, action) {
  let { writeMode } = action.payload;

  return {
    ...state,
    writeMode,
  };
}

function setDefaultValue(state, action) {
  let { propertyName, value } = action.payload;
  let { dataMapObj } = state;

  return {
    ...state,
    dataMapObj: {
      ...dataMapObj,
      data_defaults: {
        ...dataMapObj.data_defaults,
        [propertyName]: value,
      },
    },
  };
}

function setPrimaryKey(state, action) {
  let { propertyName } = action.payload;
  let { dataMapEntity, dataMapObj, writeMode } = state;
  let arePropertiesChanged = !!(dataMapEntity && dataMapEntity.map_primary_key !== propertyName);
  let newWriteMode = arePropertiesChanged ? WRITE_MODE_OVERWRITE : writeMode;

  return {
    ...state,
    dataMapObj: {
      ...dataMapObj,
      map_primary_key: propertyName,
    },
    arePropertiesChanged,
    writeMode: newWriteMode,
  };
}

function addAnotherNewRow(state, action) {
  let { dataMapObj, newRows } = state;
  newRows = clone(newRows);
  let propertiesObj = dataMapObj.map_entry_schema.properties;

  let newRow = {};
  for (var prop in propertiesObj) {
    newRow[prop] = ''; // creates an row of empty inputs
  }
  newRows.push(newRow);

  return {
    ...state,
    newRows,
  };
}

function updateRowBeingAdded(state, action) {
  let { columnPropertyName, value, rowIdx } = action.payload;
  let { newRows } = state;
  newRows = clone(newRows);
  let rowObj = clone(newRows[rowIdx]);
  if (columnPropertyName) {
    rowObj[columnPropertyName] = value;
  }
  newRows[rowIdx] = rowObj;
  return { ...state, newRows };
}

function deleteNewRow(state, action) {
  let { rowIdx } = action.payload;
  let { newRows } = state;
  newRows = clone(newRows);
  newRows.splice(rowIdx, 1);
  return { ...state, newRows };
}

function toggleKeyForm(state, action) {
  let { title, buttonLabel, id, property } = action.payload;

  if (state.isKeyFormOpen && id === state.propBeingEdited.id) {
    // if open already for the same key, then close and clear
    return {
      ...state,
      isKeyFormOpen: false,
      propBeingEdited: null,
      propBeingEditedFormerName: null,
    };
  } else if (!state.isKeyFormOpen || id !== state.propBeingEdited.id) {
    // if closed => open to add/edit. Or if open for a diff key, switch key being edited and keep open.
    let { fields, dataMapObj } = state;
    if (!fields) {
      fields = initialState.fields;
    } else {
      fields = clone(fields);
    }
    let keysArray = keys(dataMapObj.map_entry_schema && dataMapObj.map_entry_schema.properties);

    if (state.buttonLabel === 'ADD' || !property || id < 0) {
      // open to add a new key
      id = keysArray.length;

      property = {
        name: '',
        type: 'string',
        default: '',
        id: id,
        is_prime_key: false,
      };
      fields[0].value = '';
      fields[1].value = '';
      fields[2].value = false;
    } else {
      // open to edit a key, or keep open for editing a diff key
      fields[0].value = property.name;
      fields[1].value = property.default;
      fields[2].value = property.is_prime_key;
    }

    return {
      ...state,
      isKeyFormOpen: true,
      popUpFormTitle: title,
      buttonLabel: buttonLabel,
      fields: fields,
      propBeingEdited: property,
      propBeingEditedFormerName: property.name,
    };
  }
}

function onPropKeyFormFieldUpdated(state, action) {
  let { propBeingEdited, fields } = state;
  let { fieldName, text } = action.payload;
  fields = cloneDeep(fields);
  let newPrimeKeyId = null;
  if (fieldName === 'is_prime_key') {
    let wantToMakePrime = text;
    newPrimeKeyId = wantToMakePrime ? propBeingEdited.id : null; // if the primary key checkbox is unchecked, nothing happens since cant remove a primary key, only replace one.
    if (wantToMakePrime) {
      propBeingEdited = { ...propBeingEdited, is_prime_key: wantToMakePrime };
    } // only if it's being checked (text=true), not unchecked
    fields[2].value = wantToMakePrime;
  } else {
    propBeingEdited = { ...propBeingEdited, [fieldName]: text };
    fields[0].value = propBeingEdited.name;
    fields[1].value = propBeingEdited.default;
  }

  return {
    ...state,
    newPrimeKeyId: newPrimeKeyId,
    propBeingEdited: propBeingEdited,
    fields: fields,
  };
}

function deleteKey(state, action) {
  let { propBeingEditedFormerName, propBeingEdited, dataMapObj, newRows } = state;
  dataMapObj = cloneDeep(dataMapObj);

  // A) properties obj & data_defaults
  delete dataMapObj.map_entry_schema.properties[propBeingEdited.name];
  delete dataMapObj.data_defaults[propBeingEditedFormerName];

  // B) remove the key column's cellValue from every row
  const updatedNewRows = map(newRows, (rowData) => {
    const newRowData = { ...rowData };
    delete newRowData[propBeingEdited.name];
    return newRowData;
  });

  // C) dataMapObj.properties array update
  let { properties } = dataMapObj;
  let propArrWithoutDeletedOne = properties.filter((itemName) => itemName !== propBeingEdited.name);
  dataMapObj.properties = propArrWithoutDeletedOne;

  return {
    ...state,
    dataMapObj,
    isKeyFormOpen: false,
    propBeingEdited: null,
    propBeingEditedFormerName: null,
    newPrimeKeyId: null,
    newRows: updatedNewRows,
  };
}

function onSubmitPropertyForm(state, action) {
  // updates: 1) new property, 2) updated property key name, 3) changed primary key, 4) just updated default
  let {
    propBeingEdited,
    propBeingEditedFormerName,
    newPrimeKeyId,
    dataMapObj,
    buttonLabel,
    newRows,
  } = state;
  dataMapObj = cloneDeep(dataMapObj);
  let updatedNewRows = newRows;
  let propertiesObj = dataMapObj.map_entry_schema ? dataMapObj.map_entry_schema.properties : {};
  let propertiesArray = dataMapObj.properties || [];

  if (buttonLabel === 'Add' && !has(propertiesObj, propBeingEditedFormerName)) {
    updatedNewRows = map(newRows, (rowData) => ({
      ...rowData,
      [propBeingEdited.name]: '',
    }));
    let newKeyObject = {
      name: propBeingEdited.name,
      type: 'string',
      default: propBeingEdited.default,
      id: propBeingEdited.id,
      is_prime_key: propBeingEdited.is_prime_key,
    };
    propertiesObj[propBeingEdited.name] = newKeyObject;
    propertiesArray.push(newKeyObject.name);

    if (!dataMapObj.map_entry_schema) {
      dataMapObj.map_entry_schema = {};
    }

    dataMapObj.map_entry_schema.properties = propertiesObj;
    dataMapObj.properties = propertiesArray;
    dataMapObj.data_defaults[propBeingEdited.name] = propBeingEdited.default;

    if (propBeingEdited.is_prime_key) {
      dataMapObj.map_primary_key = propBeingEdited.name;

      for (let prop1 in propertiesObj) {
        // make all keys non prime before setting new prime
        propertiesObj[prop1]['is_prime_key'] = false;
      }
      propertiesObj[propBeingEdited.name].is_prime_key = true;
      dataMapObj.map_entry_schema.properties = propertiesObj;

      dataMapObj.map_primary_key = propBeingEdited.name;
    }
  } else if (
    buttonLabel === 'Save' &&
    (!has(propertiesObj, propBeingEdited.name) ||
      newPrimeKeyId ||
      newPrimeKeyId === 0 || // 2nd condition in case id is 0, falsy)
      propertiesObj[propBeingEdited.name].default !== propBeingEdited.default)
  ) {
    if (!has(propertiesObj, propBeingEdited.name)) {
      // updated name
      // A) Update rows
      updatedNewRows = map(newRows, (rowData) => {
        if (has(rowData, propBeingEditedFormerName)) {
          const newRowData = { ...rowData };
          newRowData[propBeingEdited.name] = newRowData[propBeingEditedFormerName];
          delete newRowData[propBeingEditedFormerName];

          return newRowData;
        }

        return rowData;
      });

      // B) Update propertiesObj from dataMapObj.map_entry_schema.properties
      delete propertiesObj[propBeingEditedFormerName];
      propertiesObj[propBeingEdited.name] = propBeingEdited;

      // C) Update propertiesArray, dataMapObj.properties
      let thisIndex = propertiesArray.indexOf(propBeingEditedFormerName); // fix the array index of the key's prior name, to keep col order
      if (thisIndex >= 0) {
        propertiesArray[thisIndex] = propBeingEdited.name;
      }
      dataMapObj.properties = propertiesArray;

      // D) Update name of dataMapObj.map_primary_key
      if (propBeingEdited.is_prime_key) {
        dataMapObj.map_primary_key = propBeingEdited.name;
      }

      // E) Update the data_defaults to go under new name
      let defaultUnderFormer = dataMapObj.data_defaults[propBeingEditedFormerName];
      delete dataMapObj.data_defaults[propBeingEditedFormerName];
      dataMapObj.data_defaults[propBeingEdited.name] = defaultUnderFormer;
    } // end of new key name update
    if (propertiesObj[propBeingEdited.name].default !== propBeingEdited.default) {
      // Update the key default value
      dataMapObj.data_defaults[propBeingEdited.name] = propBeingEdited.default;
      dataMapObj.map_entry_schema.properties[propBeingEdited.name].default =
        propBeingEdited.default;
    }
    if (!!newPrimeKeyId || newPrimeKeyId === 0) {
      // New primary key (2nd condition in case id is 0, falsy)
      for (let prop1 in propertiesObj) {
        // make all keys non prime before setting new prime
        propertiesObj[prop1]['is_prime_key'] = false;
      }
      propertiesObj[propBeingEdited.name].is_prime_key = true;
      dataMapObj.map_entry_schema.properties = propertiesObj;

      dataMapObj.map_primary_key = propBeingEdited.name;
    } // end of new prime update
  }

  return {
    ...state,
    dataMapObj,
    isKeyFormOpen: false,
    propBeingEdited: null,
    propBeingEditedFormerName: null,
    newPrimeKeyId: null,
    newRows: updatedNewRows,
  };
}

function setFilterRowSearchTerm(state, action) {
  return {
    ...state,
    keysSearch: action.payload,
  };
}

function closeKeyForm(state, action) {
  return {
    ...state,
    isKeyFormOpen: false,
    propBeingEdited: null,
    propBeingEditedFormerName: null,
    newPrimeKeyId: null,
  };
}

function updateMeta(state, action) {
  let { dataMapObj } = state;
  return {
    ...state,
    dataMapObj: {
      ...dataMapObj,
      [action.payload.key]: action.payload.value,
    },
  };
}

function onFirstPage(state, action) {
  return { ...state, keysPage: 1 };
}

function onPrevPage(state, action) {
  let newPage = 1;
  if (state.keysPage > 1) {
    newPage = state.keysPage - 1;
  }
  return { ...state, keysPage: newPage };
}

function onSetPage(state, action) {
  let { page } = action.payload;
  let keysPage = page;
  if (page < 1) {
    keysPage = 1;
  } else if (page > state.keysTotalPage) {
    keysPage = state.keysTotalPage;
  }
  return { ...state, keysPage };
}

function onNextPage(state, action) {
  let { keysPage, keysTotalPage } = state;
  let newKeyPage = keysPage;
  if (keysPage < keysTotalPage) {
    newKeyPage = ++keysPage;
  }
  return { ...state, keysPage: newKeyPage };
}

function onLastPage(state, action) {
  return { ...state, keysPage: state.keysTotalPage };
}
